exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".provisioning-error{position:fixed;top:0;left:0;right:0;bottom:0;z-index:10000;background-color:#fff;padding:16px;display:flex;flex-direction:column;gap:16px}", ""]);

// exports
